import { render, staticRenderFns } from "./page-cases.vue?vue&type=template&id=a08a1904&"
import script from "./page-cases.vue?vue&type=script&lang=js&"
export * from "./page-cases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports